import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "list-group" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { class: "row m-0" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar me-2" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "d-flex flex-grow-1 justify-content-evenly"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, " - ", -1)
const _hoisted_10 = { class: "row m-0" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock me-2" }, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "d-flex flex-grow-1 justify-content-evenly"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_17 = { class: "col-8" }
const _hoisted_18 = { class: "row m-0 fw-bold" }
const _hoisted_19 = { class: "row m-0" }
const _hoisted_20 = { class: "m-auto h4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingEvents, (singleEvent) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "list-group-item",
        key: singleEvent
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                (!singleEvent.endDate || singleEvent.startDate === singleEvent.endDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.moment( singleEvent.startDate ).format( _ctx.$t( 'moment.formatDate' ) )), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.moment( singleEvent.startDate ).format( _ctx.$t( 'moment.formatDate' ) )), 1),
                      _hoisted_9,
                      _createElementVNode("div", null, _toDisplayString(_ctx.moment( singleEvent.endDate ).format( _ctx.$t( 'moment.formatDate' ) )), 1)
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                (!singleEvent.endTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(singleEvent.startTime), 1))
                  : _createCommentVNode("", true),
                (!singleEvent.endDate || singleEvent.startDate === singleEvent.endDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(singleEvent.startTime) + " - " + _toDisplayString(singleEvent.endTime), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", null, _toDisplayString(singleEvent.startTime), 1),
                      _hoisted_16,
                      _createElementVNode("div", null, _toDisplayString(singleEvent.endTime), 1)
                    ]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.event.name), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.getLocationName( singleEvent.locationIds, _ctx.event, _ctx.$i18n, 45 )), 1)
          ])
        ])
      ]))
    }), 128)),
    (!_ctx.everythingLoaded)
      ? (_openBlock(), _createElementBlock("li", {
          key: 0,
          class: "list-group-item d-flex cursor-pointer bg-secondary text-light",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMoreEvents && _ctx.loadMoreEvents(...args)))
        }, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t( 'common.loadMore' )), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}